export const ChargebacksTabs = {
	AllMerchants: {
		name: "all-merchants",
		displayName: "All Merchants",
		filterFormName: "AllMerchants",
	},
	InReview: {
		name: "in-review",
		displayName: "In Review",
		filterFormName: "InReview",
	},
	FollowUp: {
		name: "follow-up",
		displayName: "Follow Up",
		filterFormName: "followUp",
	},
	Historical: {
		name: "historical",
		displayName: "Historical",
		filterFormName: "Historical",
	},
};

export const getChargebacksBreadcrumbsPageTitle = tab => {
	if (tab === ChargebacksTabs.AllMerchants.name)
		return ChargebacksTabs.AllMerchants.displayName;
	else if (tab === ChargebacksTabs.Historical.name)
		return ChargebacksTabs.Historical.displayName;
	else return ChargebacksTabs.InReview.displayName;
};
